module.exports = __webpack_public_path__ + "img/thumbnail_Koala_j_albino.71827d79.png";